import React from 'react';

interface Props {
  width?: number;
  height?: number;
}

export function IconDeleteAll(props: Props) {
  const { width = 24, height = 24 } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.2 15.2016H16.8C17.24 15.2016 17.6 15.5616 17.6 16.0016C17.6 16.4416 17.24 16.8016 16.8 16.8016H15.2C14.76 16.8016 14.4 16.4416 14.4 16.0016C14.4 15.5616 14.76 15.2016 15.2 15.2016ZM15.2 8.80156H19.2C19.64 8.80156 20 9.16156 20 9.60156C20 10.0416 19.64 10.4016 19.2 10.4016H15.2C14.76 10.4016 14.4 10.0416 14.4 9.60156C14.4 9.16156 14.76 8.80156 15.2 8.80156ZM15.2 12.0016H18.4C18.84 12.0016 19.2 12.3616 19.2 12.8016C19.2 13.2416 18.84 13.6016 18.4 13.6016H15.2C14.76 13.6016 14.4 13.2416 14.4 12.8016C14.4 12.3616 14.76 12.0016 15.2 12.0016ZM4.8 16.8016C4.8 17.6816 5.52 18.4016 6.4 18.4016H11.2C12.08 18.4016 12.8 17.6816 12.8 16.8016V8.80156H4.8V16.8016ZM12.8 6.40156H11.2L10.632 5.83356C10.488 5.68956 10.28 5.60156 10.072 5.60156H7.528C7.32 5.60156 7.112 5.68956 6.968 5.83356L6.4 6.40156H4.8C4.36 6.40156 4 6.76156 4 7.20156C4 7.64156 4.36 8.00156 4.8 8.00156H12.8C13.24 8.00156 13.6 7.64156 13.6 7.20156C13.6 6.76156 13.24 6.40156 12.8 6.40156Z"
        fill="#f97316"
      />
    </svg>
  );
}
